"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubModeEntreeRelationCorporation = void 0;
exports.ESubModeEntreeRelationCorporation = {
    rdv_physique: "rdv_physique",
    rdv_distance: "rdv_distance",
};
